<template>
  <v-app>
    <router-view />
    <app-snackbar />
  </v-app>
</template>

<script lang="ts" setup>
</script>
<style scoped>
</style>
